import styles from './Sign.scss';
import { Component } from 'react';
import {
    SigningIframe
} from 'part11/components/SigningIframe/SigningIframe';
import { getAuthCredentials } from 'common/util/auth-storage';

export class Sign extends Component{
    sign(values){
        this.props.onSign(values);
    }

    render(){
        const { accessToken } = getAuthCredentials();
        const loginUrl = `${this.props.baseUrl}/sign?access_token=${accessToken}`;

        return (
            <div className={styles.sign} data-cy="Sign">
                <span className={styles.acknowledgementText}>
                    I have reviewed, acknowledge, accept, and agree with the information presented herein.
                </span>
                <SigningIframe
                    url={loginUrl}
                    signDocument={this.sign.bind(this)}
                    width="100%"
                    height="300px" />
            </div>
        );
    }
}
